import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { StateType } from './state-type.enum';

@Api('api/agentic-cx/state-definition')
export class StateDefinitionDto extends DtoHasApi {
  id = 0;
  name = '';
  description?: string;
  typeId: StateType = StateType.Work;
  isActive = true;
  isPredefined = false;
}
